var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.5123 5.75283C20.3347 5.97424 20.9831 6.62267 21.2045 7.44508C21.6157 8.94754 21.5999 12.079 21.5999 12.079C21.5999 12.079 21.5999 15.1946 21.2045 16.6971C20.9831 17.5195 20.3347 18.1679 19.5123 18.3893C18.0098 18.7847 12 18.7847 12 18.7847C12 18.7847 6.00592 18.7847 4.48764 18.3735C3.66524 18.1521 3.0168 17.5037 2.79539 16.6813C2.4 15.1946 2.4 12.0632 2.4 12.0632C2.4 12.0632 2.4 8.94754 2.79539 7.44508C3.0168 6.62267 3.68105 5.95843 4.48764 5.73701C5.9901 5.34163 12 5.34163 12 5.34163C12 5.34163 18.0098 5.34163 19.5123 5.75283ZM10.2418 9.82267L14.132 12.0632L10.2418 14.3037V9.82267Z","fill":"black"}));
}

Youtube.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
